import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import { useNavigate, useParams } from 'react-router-dom'
import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import withAppStore from '../../util/withAppStore'

import AppStore from '../../stores/AppStore'

import styles from '../../../css/devicePage.module.css'
import ApiKeyModuleCreate from '../partials/SupportPageComponents/ApiKeyCreate'

function ApiKeyCreatePage (props) {
  const navigate = useNavigate()
  const { customerID } = useParams()

  const goBack = React.useCallback(() => {
    navigate(`/support/${customerID}/apiKeys`)
  }, [customerID, navigate])

  React.useEffect(() => {
    window.scrollTo(0, 0) // start at top
  }, [])

  const {
    auth: { logout: logoutFn },
    intl: { formatMessage },
    route: { path: page },
    data: {
      user: {
        permissions: currentPermission,
      },
    },
  } = props

  const logout = () => logoutFn(navigate)

  if (currentPermission.level < 20) {
    navigate('/support')
  }

  const ApiKey = formatMessage({ id: 'support.api.createAPI', defaultMessage: 'Create Altrac API Key' })

  return (
    <div>
      <Helmet><title>{ApiKey}</title></Helmet>
      <NavigationBar
        backFunc={goBack}
        name={ApiKey}
        page={page}
        logOut={logout}
      />

      <div className={styles.pageWidth}>
        <div>
          <ApiKeyModuleCreate
            user={AppStore.getUser()}
            customerID={customerID}
            router={navigate}
          />
        </div>
        <div className={styles.endSpace} />
      </div>
      <Footer />
    </div>
  )
}

ApiKeyCreatePage.propTypes = {
  auth: PropTypes.object,
  intl: PropTypes.object,
  route: PropTypes.object,
  data: PropTypes.object,
}

export default withAppStore(injectIntl(ApiKeyCreatePage))
